export default __webpack_public_path__ + "static/media/Setting-icon.776c4cdd.svg";